// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"PaymentPreference_themeRoot__2qfon","toggleThemeChange":"PaymentPreference_toggleThemeChange__2Uw7X","modalBoxWidth":"PaymentPreference_modalBoxWidth__CutVo"};